import React, { useState } from 'react'
import Loader from '../Loader/Loader'
import { message, Button } from 'antd'
import * as Yup from 'yup'
import { useFormik } from 'formik'
import { updateUser } from '../../Web Apis/Apis'
import Avtar from '../../Images/avatar.png'


function EditUser({ showUpdateModal, setShowUpdateModal, selectedUser, action, setAction }) {
    const [open, setOpen] = useState(showUpdateModal)
    const [loading, setLoading] = useState(false)

    const closeEditModal = () => {
        setOpen(false)
        setShowUpdateModal(false)
    }



function formatToDateTimeLocal(dateString) {
    if(dateString === null){
        return null
    }
  const date = new Date(dateString); // UTC date
  const tzOffset = date.getTimezoneOffset() * 60000; // offset in milliseconds
  const localDate = new Date(date.getTime() - tzOffset); // convert to local time
  return localDate.toISOString().slice(0, 16); // format to "YYYY-MM-DDTHH:MM"
}

    const formik = useFormik({
        initialValues: {
            firstName: selectedUser.firstName,
            lastName: selectedUser.lastName,
            email: selectedUser.email,
            active: selectedUser.active,
            phone: selectedUser.phone,
            subscriptionPlan: selectedUser.subscriptionPlan,
            expirationDate: formatToDateTimeLocal(selectedUser.adminUpgradeExpiresAt),
            coins: 0
        },
        validationSchema: Yup.object({
            firstName: Yup.string().required("First name is required").max(15, "First name should not be more than 15 characters").min(2, "Fist name should be atleast 2 characters long").matches(/^[A-Za-z]+$/, "First name should contain only letters without spaces or special characters"),
            lastName: Yup.string().required("Last name is required").max(15, "Last name should not be more than 15 characters").min(2, "Fist name should be atleast 2 characters long").matches(/^[A-Za-z]+$/, "Last name should contain only letters without spaces or special characters"),
        }),
        onSubmit: async (values, { resetForm, setSubmitting }) => {
            setLoading(true)
            try {

                const UTCTIME = new Date(values.expirationDate).toISOString().replace('00.000Z', '00Z');
              
                const response = await updateUser(
                    selectedUser.id,
                    {
                        ...values,
                    }, UTCTIME
                )
                if(response?.data?.success){
                    message.success(response?.data?.message)
                    resetForm()
                    setOpen(false)
                    setShowUpdateModal(false)
                    setAction(!action)
                }


            } catch (error) {
                console.log("Error while edit admin", error.message)
                message.error(error?.response?.data?.message || "Error while edit admin profile")
            } finally {
                setSubmitting(false)
                setLoading(false)
            }
        }
    })


    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white  rounded-lg shadow-lg w-[900px] h-[600px] overflow-y-auto">
                <h3 className="text-xl font-bold mb-1 text-center bg-gradient-to-br from-blue-950 to-blue-500 py-2 text-white">
                    Update User Details
                </h3>
                <form onSubmit={formik.handleSubmit} className='p-8 '>
                    <div className="flex gap-2 ">
                        <div className="w-full mt-2">
                            <label className="block mb-1">First Name</label>
                            <input
                                type="text"
                                name="firstName"
                                className="border border-gray-800 p-2 w-full"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.firstName}
                                placeholder="Enter user's first name"
                            />
                            {formik.errors.firstName && (
                                <p className="text-red-600">{formik.errors.firstName}</p>
                            )}
                        </div>
                        <div className="w-full mt-2">
                            <label className="block mb-1">Last Name</label>
                            <input
                                type="text"
                                name="lastName"
                                className="border border-gray-800 p-2 w-full"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.lastName}
                                placeholder="Enter user's last name"
                            />
                            {formik.errors.lastName && (
                                <p className="text-red-600">{formik.errors.lastName}</p>
                            )}
                        </div>
                    </div>

                     <div className="flex gap-2 justify-center ">
                    <div className="w-full mt-4">
                        <label className="block mb-1">Email</label>
                        <input
                            type="text"
                            name="email"
                            className="border border-gray-800 p-2 w-full"

                            value={selectedUser.email}
                            disabled
                        />
                    </div>

                    <div className="w-full mt-4">
                            <label className="block mb-1">Phone</label>
                            <input
                                type="text"
                                name="phone"
                                className="border border-gray-800 p-2 w-full"
                                // onChange={formik.handleChange}
                                // onBlur={formik.handleBlur}
                                value={formik.values.phone}
                                // placeholder="Enter user's phone number"
                                disabled
                            />
                        </div>
                    </div>

                            

                    <div className="flex gap-2 justify-center ">
                        <div className="w-full mt-4">
                        <label className="block mb-1">Subscription Plan</label>
                       <select
                                    type="text"
                                    name="subscriptionPlan"
                                    className={`border border-gray-800 p-3 w-full ${selectedUser.adminUpdatedPlan === false && selectedUser.subscriptionPlan === "PREMIUM" ? "bg-gray-100" : "bg-white"} `}
                                    value={formik.values.subscriptionPlan}
                                    onChange={formik.handleChange}
                                    disabled={selectedUser.adminUpdatedPlan === false && selectedUser.subscriptionPlan === "PREMIUM"}
                                >
                                    <option value="BASIC">BASIC</option>
                                    <option value="PREMIUM">PREMIUM</option>
                                </select>
                    </div>
                        
                        <div className="w-full mt-4"> 
                            <label className="block mb-1">Status</label>
                                <select
                                    type="text"
                                    name="active"
                                    className={`border border-gray-800 p-3 w-full bg-white`}
                                    value={(formik.values.active === true) ? 'Active' : 'Inactive'}
                                    onChange={(e) => {
                                        const isActive = e.target.value == "Active" ? true : false; // Convert "Active" to true, "Inactive" to false
                                        formik.setFieldValue('active', isActive); // Update Formik's "status" field with boolean
                                    }}
                                >
                                    <option value="Active">Active</option>
                                    <option value="Inactive">Inactive</option>
                                </select>
                            
                        </div>
                    </div>

                    <div className="flex gap-2 justify-center ">
                                 <div className="w-full mt-4">
                        <label className="block mb-1">Subscription Expire</label>
                        <input
                            type="datetime-local"
                            name="expirationDate"
                            className="border border-gray-800 p-2 w-full "
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.expirationDate}
                            placeholder='Enter subscription expire date'

                            disabled={formik.values.subscriptionPlan === 'BASIC'}
                            
                        />
                        {formik.errors.expirationDate && (
                            <p className="text-red-600 ml-2">{formik.errors.expirationDate}</p>
                        )}
                    </div>

                    <div className="w-full mt-4">
                            <label className="block mb-1">Add Coins</label>
                            <input
                                type="text"
                                name="coins"
                                className="border border-gray-800 p-2 w-full"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.coins}
                                placeholder="Enter coin amount to be added"
                            />
                        </div>
                            </div>

                    <div className="w-full mt-4">
                        <label className='block mb-1'>Profile Picture</label>
                        <img
                            src={selectedUser?.profileImageUrl || Avtar}
                            alt='Profile Pic'
                            className='h-32 w-32 object-cover rounded-full'
                        >
                        </img>
                    </div>

                    <div className="flex justify-end gap-6 mt-6 mb-2">
                        <button onClick={closeEditModal} className="bg-gray-300 border border-gray-800 text-black w-52 py-2 px-4 rounded-md hover:bg-gray-400 transition duration-200">
                            Close
                        </button>

                        <button type="submit" className="bg-blue-500 text-white py-2 px-4 rounded-md w-52 hover:bg-blue-600 transition duration-200 mr-2">
                            Update
                        </button>

                    </div>
                    {loading && <Loader />}
                </form>
            </div>
        </div>
    )
}

export default EditUser